import getMapData from "./component-library429.mjs";
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}
export {
  mapCacheHas as default
};
